import { NETWORK_WARNINGS_INACTIVE, NETWORK_WARNINGS_ACTIVE } from "./api";

export const toggleNetworkWarnings = (status) => {
  return { type: status ? NETWORK_WARNINGS_ACTIVE : NETWORK_WARNINGS_INACTIVE };
};
